// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2729":"c2adbd32","4362":"27d68c1d","5556":"acb4b3af","6618":"acb4b3af"}[chunkId] + ".chunk.css";
};